import * as React from 'react';
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { getDataSourceFromChildren } from '@/utils/func';
import isFunction from 'lodash/isFunction';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import { getItemsFromDataSource } from '@/utils/tree';
import { useFormLayout } from '@/form/cn-form-layout';
import { CnReadonly } from '@/components/cn-readonly';
import { CnRadio } from './cn-radio';
import './cn-radio-group.scss';
const getInitValue = (props) => {
    let ret = [];
    if ('defaultValue' in props) {
        ret = props.defaultValue;
    }
    if ('value' in props) {
        ret = props.value;
    }
    return ret;
};
export const CnRadioGroup = (props) => {
    const { size, direction, children, disabled: groupDisabled, defaultValue, value, onChange, className, readOnly, readOnlyRender, dataSource, shape, ...others } = props;
    const prefix = 'cn-ui-m-';
    const [groupValue, setGroupValue] = useState(getInitValue(props));
    const isControlled = 'value' in props;
    const isButton = shape === 'button';
    const { labelAlign = 'left' } = useFormLayout();
    const groupCls = classNames(`${prefix}radio-group`, `${prefix}radio-group--${labelAlign}-${size}`, className, {
        [`${prefix}radio-group-form`]: props.insideForm,
        [`${prefix}radio-group--${direction}`]: !isButton,
        [`${prefix}radio-button`]: isButton,
    });
    useEffect(() => {
        const newValue = getInitValue(props);
        if (isControlled) {
            setGroupValue(newValue);
        }
    }, [value, groupValue]);
    const handleChange = (selected, radioValue, e, isDisabled) => {
        if (!isDisabled && !readOnly) {
            if (!isControlled) {
                setGroupValue(radioValue);
            }
            // 新 radio 被选中时，处理 onChange 回调
            if (selected && isFunction(onChange)) {
                onChange(radioValue, e);
            }
        }
    };
    let content;
    let ds = dataSource;
    if (!ds && React.Children.count(children) > 0) {
        ds = getDataSourceFromChildren(children);
    }
    if (Array.isArray(ds)) {
        content = ds.map((item, index) => {
            let itemData = {
                style: {},
                value: null,
                checked: false,
                label: '',
                text: '',
                disabled: false,
                size,
            };
            const { onClick: itemOnClick, onChange: itemOnChange, className: itemClassName, label: itemLabel, text: itemText, ...itemRest } = item;
            if (isString(item) || isNumber(item)) {
                // @ts-ignore
                itemData.value = item;
            }
            else {
                itemData = { ...itemData, ...itemRest };
            }
            const isDisabled = groupDisabled || itemData.disabled;
            const label = itemLabel || itemText || itemData.value;
            const isLast = index === ds.length - 1;
            const checked = itemData.value === groupValue;
            return (React.createElement(React.Fragment, null,
                React.createElement(CnRadio, { ...itemData, key: `radio_${index}`, className: classNames(itemClassName, `${prefix}radio-item`, {
                        [`${prefix}radio-item--${direction}-${size}`]: !isLast,
                        [`${prefix}radio-item--selected`]: checked,
                        [`${prefix}radio-item--disabled`]: isDisabled,
                    }), disabled: isDisabled, checked: checked, onChange: (selected, e) => {
                        if (isFunction(itemOnChange)) {
                            itemOnChange(selected, e);
                        }
                        handleChange(selected, itemData.value, e, isDisabled);
                    }, onClick: itemOnClick }, label),
                isButton && !isLast ? (React.createElement("div", { className: classNames(`${prefix}radio-item-separator`, {
                        [`${prefix}radio-item-separator--hidden`]: checked ||
                            (ds[index + 1] && ds[index + 1].value === groupValue),
                    }) })) : null));
        });
    }
    if (readOnly) {
        const arr = getItemsFromDataSource(ds, groupValue);
        let previewItem = {};
        if (Array.isArray(arr) && arr.length > 0) {
            previewItem = arr[0];
        }
        if (isFunction(readOnlyRender)) {
            return React.createElement("div", null, readOnlyRender(props));
        }
        return React.createElement(CnReadonly, null, previewItem.label || previewItem.text);
    }
    return (React.createElement("div", { className: groupCls, ...others }, content));
};
CnRadioGroup.displayName = 'CnRadioGroup';
CnRadioGroup.defaultProps = {
    size: 'medium',
    direction: 'hoz',
};
